import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DataTableComponent } from './data-table/data-table.component';
import { PasswordInputComponent } from './password-input/password-input.component';

import { InterceptorService } from './services/interceptor/interceptor.service';
import { RouterModule } from '@angular/router';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import {
	UploadPricingDataComponent,
	UploadPricingDataDialog,
} from './upload-pricing-data/upload-pricing-data.component';
import { UploadPricingStepOneComponent } from './upload-pricing-data/upload-pricing-step-one/upload-pricing-step-one.component';
import { UploadPricingStepTwoComponent } from './upload-pricing-data/upload-pricing-step-two/upload-pricing-step-two.component';
import { DefaultProgressBarComponent } from './default-progress-bar/default-progress-bar.component';
import { SearchPipe } from '@shared/search.pipe';
import { UserSelectorComponent } from './user-selector/user-selector.component';
import { DocsDialogComponent } from './docs-dialog/docs-dialog.component';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';

// commons module
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

const imports = [
	MatAutocompleteModule,
	MatBadgeModule,
	MatBottomSheetModule,
	MatButtonToggleModule,
	MatCheckboxModule,
	MatExpansionModule,
	MatFormFieldModule,
	MatIconModule,
	MatListModule,
	MatGridListModule,
	MatMenuModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatRadioModule,
	MatSidenavModule,
	MatSliderModule,
	MatSlideToggleModule,
	MatSortModule,
	MatStepperModule,
	MatTableModule,
	MatTooltipModule,
	ReactiveFormsModule,
	FormsModule,
	HttpClientModule,
	RouterModule,
	MtxPopoverModule,
	NgxDocViewerModule,
	MatTabsModule,

	FlexLayoutModule,
	MatDialogModule,
	MatDividerModule,
	MatButtonModule,
	MatInputModule,
	MatCardModule,
	MatToolbarModule,
	MatProgressBarModule,
	MatSnackBarModule,
	MatDatepickerModule,
	MatNativeDateModule,
	MatChipsModule,
	MatSelectModule,
];

const components = [
	DataTableComponent,
	PasswordInputComponent,
	UploadPricingDataComponent,
	UploadPricingDataDialog,
	UploadPricingStepOneComponent,
	UploadPricingStepTwoComponent,
	DefaultProgressBarComponent,
	SearchPipe,
	UserSelectorComponent,
	DocsDialogComponent,
];

@NgModule({
	declarations: [components],
	imports: [CommonModule, imports],
	providers: [{ provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true }],
	exports: [...imports, ...components],
})
export class CoreModule {}
